var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F6B119",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.971 3.34 1.374-1.373v9.176a.568.568 0 1 0 1.136 0V1.967l1.374 1.374a.567.567 0 1 0 .803-.805L3.316.194A.582.582 0 0 0 3.13.07L3.12.067a.547.547 0 0 0-.414 0l-.01.003a.58.58 0 0 0-.186.124L.167 2.537a.57.57 0 1 0 .804.804zM10.715 8.398 9.342 9.772V.595a.568.568 0 1 0-1.136 0V9.77L6.832 8.397a.57.57 0 0 0-.805.805l2.344 2.343a.582.582 0 0 0 .187.124l.008.003a.547.547 0 0 0 .415 0l.01-.003a.58.58 0 0 0 .186-.124l2.343-2.343a.57.57 0 1 0-.805-.804z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.3e6e5576fcddf2c6980b83e0d0976be7.svg";
export { ForwardRef as ReactComponent };